import { render, staticRenderFns } from "./MicrophoneIcon.vue?vue&type=template&id=d58a55bc"
import script from "./MicrophoneIcon.vue?vue&type=script&lang=js"
export * from "./MicrophoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports